<script>
  import { CollapseItem } from 'element-ui'
  export default {
    name:'ElCollapseItem',
    extends:CollapseItem
  }
</script>
